import React, {Component} from 'react';

import './Modal.css';

import Backdrop from '../Backdrop/Backdrop';

import { connect } from 'react-redux';

class Modal extends Component {

    // shouldComponentUpdate(nextProps, nextState) {
        
    //         return nextProps.show !== this.props.show || nextProps.children !== this.props.children;
        
    // }
    render() {
        return(
            <>
            <Backdrop show={this.props.show} clicked={this.props.modalClosed}/>
            <div 
                className='KurzModal'
                style={{
                    transform: this.props.show ? 'translateY(-50%)' : 'translateY(-300vh)',
                    opacity: this.props.show ? '1': '0'
                }}>
                <div className='KurzCloseDiv' ><text className="KurzCloseText" onClick={this.props.modalClosed}>x</text></div>
                  <img id="ModalImg" src={this.props.img} alt="test" />
            </div>
        </>
        )
    }
}

const mapStateToProps = state => {
    return {
        img: state.text.modalImg
    }
}

export default connect(mapStateToProps)(Modal);